import React from "react";
import { useAuthContext } from "../context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
  /**
   * @deprecated use rolesAllowed instead
   */
  role?: string | string[];
  /**
   * Required roles allowed to access the route
   */
  rolesAllowed?: string[];
  adminOnly?: boolean;
  allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  role,
  rolesAllowed,
  adminOnly = false,
  allowedRoles,
}) => {
  const { user, roles, role: userRole, loading } = useAuthContext();
  const location = useLocation();

  // While loading (e.g., on refresh), show a spinner
  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-white">
        <svg
          className="animate-spin h-8 w-8 text-primary"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          ></path>
        </svg>
        <span className="ml-4 text-lg font-semibold text-primary">Loading...</span>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  if (adminOnly && userRole !== "admin" && !roles.includes("admin"))
    return <Navigate to="/unauthorized" replace />;

  const allowed = rolesAllowed || (role ? (Array.isArray(role) ? role : [role]) : null);
  if (allowed && !allowed.some(r => roles.includes(r)))
    return <Navigate to="/unauthorized" replace />;

  if (allowedRoles && !allowedRoles.some(r => roles.includes(r)))
    return <Navigate to="/unauthorized" replace />;
  return <>{children}</>;
};

export default ProtectedRoute;
